@let action =
  actionsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();

@if (action) {
  @let actionTitle = actionTitleSg();
  @let rawRendering =
    actionTestingPlugin.feature.selectors.currentActionRawRendering.asSignal();
  @let loading = loadingSg();
  @let isNew = isNewSg();

  <atn-ds-centered-overlay type="full-width">
    <div class="action-dialog">
      <atn-ds-widget
        [title]="actionTitle"
        class="action-dialog__widget"
      >
        <div
          actions
          class="action-dialog__header-icons"
        >
          <i
            class="atn-icon atn-run atn-blue"
            (click)="runClickHandler()"
          ></i>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>

        <!-- ---------------------------- Main Content ----------------------------- -->
        <div class="action-dialog__action-content">
          <div class="action-dialog__info-container">
            <atn-ds-text
              label="Name"
              placeholder="Enter a name"
              [value]="action.name"
              (change)="updateAction('name', $event ?? '')"
            ></atn-ds-text>
            <atn-ds-text
              label="Alias"
              placeholder="Used to reference this action"
              [value]="action.alias"
              (change)="updateAction('alias', $event ?? '')"
            ></atn-ds-text>
            <atn-ds-text
              label="Description"
              placeholder="Enter a description"
              [value]="action.description"
              (change)="updateAction('description', $event)"
            ></atn-ds-text>
            <atn-ds-code
              class="action-dialog__query-editor"
              label="Query"
              syntax="dms-query"
              [json]="action.query"
              (jsonChange)="updateActionQuery($event)"
            />
            <!-- <p>TODO: variables</p>
            <p>TODO: preview variable values</p> -->
          </div>
          <div class="action-dialog__preview-container">
            <atn-ds-floating-horizontal-tabs>
              <ng-template
                atnDsTab
                name="Design view"
              >
                <div>
                  TODO: show the action rendering with run button(s) to run/test
                  the rendering(s)
                </div>
              </ng-template>
              <ng-template
                atnDsTab
                name="JSON view"
              >
                <atn-ds-code
                  [json]="rawRendering"
                  [readonly]="true"
                />
                ></ng-template
              >
            </atn-ds-floating-horizontal-tabs>
          </div>
        </div>
      </atn-ds-widget>

      @if (loading) {
        <atn-ds-loader
          [message]="isNew ? 'Updating Action...' : 'Creating Action...'"
        />
      }

      <!-- ------------------------------- Footer -------------------------------- -->
      <div class="action-dialog__footer">
        <atn-ds-button
          class="action-dialog__footer-cancel-btn"
          type="transparent"
          (click)="cancelClickHandler()"
          [disabled]="loading"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          (click)="saveClickHandler()"
          [disabled]="loading"
          >{{ isNew ? 'Create' : 'Update' }}</atn-ds-button
        >
      </div>
    </div>
  </atn-ds-centered-overlay>
}
